import { useEffect } from "react";

import { Drawer } from "@mui/material";

import { DrawerContent } from "./components/DrawerContent";
import { useDrawerStore } from "./hooks/useDrawerStore";

const ReportQuickView = () => {
  const { isOpen, closeDrawer } = useDrawerStore();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isOpen) {
        closeDrawer();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, closeDrawer]);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={closeDrawer}
      PaperProps={{ sx: { minWidth: 600, width: "25%", maxWidth: 1200, height: "98vh", borderRadius: 1, m: 2 } }}
    >
      <DrawerContent />
    </Drawer>
  );
};

export default ReportQuickView;
